export class BusinessOverviewFee {
  /**
   * Example type of aircraft this fee applies to (ex. Cessna 172, Beechcraft Baron)
   */
  airframe: string;

  /**
   * Landing fee if there is one, null otherwise
   */
  landing: number;

  /**
   * Landing fee if there is one, null otherwise
   */
  ramp: number;

  /**
   * Landing fee if there is one, null otherwise
   */
  handling: number;

  static parse(data: any): BusinessOverviewFee {
    return {
      airframe: data.airframe,
      landing: data.landing,
      ramp: data.ramp,
      handling: data.handling
    };
  }
}
